import mediaUrl from "../../utils/mediaUrl";
import React, { useEffect, useRef, useState } from "react";
import Header from "../Header";
import Footer from "../Footer";
import auth from "../../utils/auth";
import "../../assets/css/home.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import axios from "axios";
import { Link } from "react-router-dom";
import { IonPage } from "@ionic/react";

const Home = (props) => {
	const [isOpaque, setIsOpaque] = useState(true);
	const [courses, setCourses] = useState([]);
	const [allCourses, setAllCourses] = useState([]);
	const [categories, setCategories] = useState([]);
	const [currentTab, setCurrentTab] = useState("");
	const filterTrackRef = useRef(null);

	const scrollFilter = (direction) => {
		filterTrackRef.current?.scrollBy({
			left: direction * 280,
			behavior: "smooth",
		});
	};

	const handleSearch = (e) => {
		// console.log(e.target.value) ;
		setCourses(
			allCourses.filter((c) => {
				return c.name.toLowerCase().includes(e.target.value.toLowerCase());
			})
		);
	};

	const isActive = (tabName) => {
		return currentTab == tabName ? "active" : "";
	};

	const handleTab = (categoryId) => {
		const filtered = categoryId
			? allCourses.filter((c) => String(c.category) === String(categoryId))
			: allCourses;
		setCourses(filtered.slice(0, 3));
		setCurrentTab(categoryId);
	};

	useEffect(() => {
		const config = {
			headers: {
				"Content-Type": "application/json",
				"x-auth-token": auth.getToken(),
			},
		};

		window.addEventListener("load", () => {
			registerSW();
		});

		// Register the Service Worker
		async function registerSW() {
			if ("serviceWorker" in navigator) {
				try {
					await navigator.serviceWorker.register("./serviceworker.js");
				} catch (e) {
					console.log("SW registration failed");
				}
			}
		}

		window.addEventListener("scroll", (e) => {
			if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
				setIsOpaque(false);
			} else {
				setIsOpaque(true);
			}
		});

		axios
			.get(`/courses`, config)
			.then((res) => {
				const visible = res.data.courses.filter((c) => c.status !== "draft");
				setCourses(visible.slice(0, 3));
				setAllCourses(visible);
			})
			.catch((err) => console.log(err));

		axios
			.get(`/categories`)
			.then((res) => setCategories(res.data.categories))
			.catch((err) => console.log(err));

		return () => {
			window.removeEventListener("scroll", (e) => {
				if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
					setIsOpaque(false);
				} else {
					setIsOpaque(true);
				}
			});
		};
	}, []);

	return (
		<IonPage>
			<div>
				<div id="header_place">
					<Header isOpaque={isOpaque} isBlue={true}></Header>
				</div>
				<section id="hero_area">
					<div className="center_wrapper2">
						<div>
							<h1>
								Grow within your organization by acquiring the right skills
							</h1>
						</div>
						<div>
							<h3>Choose from the array of curated online courses</h3>
						</div>

						<div className="card1">
							<div>
								<div>
									<img src={`${process.env.PUBLIC_URL}/assets/key.png`} />
									<div>
										Access more than <br />
										100+ online courses
									</div>
								</div>
								<div>
									<img src={`${process.env.PUBLIC_URL}/assets/play.png`} />
									<div>
										Multilingual Byte <br />
										Sized Lessons
									</div>
								</div>
								<div>
									<img src={`${process.env.PUBLIC_URL}/assets/medal.png`} />
									<div>
										Industry Valid <br />
										Certification
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section id="our_courses">
					<div className="center_wrapper">
						<div id="our_courses_header">
							<div>
								<h2>Our courses</h2>
							</div>
							<div>
								<div className="search_box">
									<input
										onChange={(e) => handleSearch(e)}
										placeholder="Search for course"
										id="search"
									/>
									<svg
										className="search_icon"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										aria-hidden="true"
									>
										<circle cx="10.5" cy="10.5" r="6.75" stroke="currentColor" strokeWidth="1.8" />
										<line x1="15.6" y1="15.8" x2="20.3" y2="20.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
									</svg>
								</div>
							</div>
						</div>

						<div className="course_filter">
							<button
								type="button"
								className="filter_arrow"
								aria-label="Scroll categories left"
								onClick={() => scrollFilter(-1)}
							>
								<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
									<polyline
										points="14.5,6 9.5,12 14.5,18"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
							<div className="filter_track" ref={filterTrackRef}>
								<div
									className={isActive("") + " tab"}
									onClick={() => handleTab("")}
								>
									All
								</div>
								{categories.map((cat) => (
									<div
										key={cat._id}
										className={isActive(cat._id) + " tab"}
										onClick={() => handleTab(cat._id)}
									>
										{cat.name}
									</div>
								))}
							</div>
							<button
								type="button"
								className="filter_arrow"
								aria-label="Scroll categories right"
								onClick={() => scrollFilter(1)}
							>
								<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
									<polyline
										points="9.5,6 14.5,12 9.5,18"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
						</div>
						<br />
						<br />
						<div className="courses_cards">
							{courses.map((course) => (
								<div key={course._id} className="course">
									<img
										className="course_image"
										src={mediaUrl(course.thumbnail)}
										alt={course.name}
									/>
									<div className="course_title">{course.name}</div>
									<div className="course_description">{course.description}</div>
									<div className="course_attributes">
										<div className="time">
											<svg
												className="time_icon"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
												aria-hidden="true"
											>
												<circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
												<path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
											</svg>
											{course.duration || "15 Min."}
										</div>
										<div className="inr">
											{course.currency || "INR"} {course.price}/-
										</div>
									</div>
									{course.status === "comingSoon" ? (
										<button className="know_more coming_soon" disabled>
											Coming Soon
										</button>
									) : (
										<Link to={`/courses/${course._id}`} className="know_more">
											Know More
										</Link>
									)}
								</div>
							))}
							{courses.length === 0 && (
								<div className="course_description" style={{ padding: 20 }}>
									No courses yet.
								</div>
							)}
						</div>
						<Link to="/courses" className="yellow_btn" id="explore_all">
							Explore All Courses
						</Link>
					</div>
				</section>

				<section id="learning_process">
					<div className="center_wrapper">
						<h2>Our Learning Process</h2>
						<div id="process_cards">
							<div>
								<div className="title_no">01</div>
								<img
									src={`${process.env.PUBLIC_URL}/assets/process_find.svg`}
									alt=""
									className="card_icon"
								/>
								<div className="card_title">Find a course</div>
								<div className="card_content">
									Upskill your employees internally with these online training
									courses from Wyden, designed to give the skills you need to
									accelerate your employee training and boost your business
									performance.
								</div>
							</div>
							<div>
								<div className="title_no">02</div>
								<img
									src={`${process.env.PUBLIC_URL}/assets/process_enroll.svg`}
									alt=""
									className="card_icon"
								/>
								<div className="card_title">Book a seat</div>
								<div className="card_content">
									Once you've found the classNamees you want your employees to
									take, you can go directly to ‘enroll now’ to register. We will
									help you transition to the industry mold, and keep you updated
									with the latest industry expectations and functions.{" "}
								</div>
							</div>
							<div>
								<div className="title_no">03</div>
								<img
									src={`${process.env.PUBLIC_URL}/assets/process_certificate.svg`}
									alt=""
									className="card_icon"
								/>
								<div className="card_title">Get a certificate</div>
								<div className="card_content">
									When you complete a Wyden course you will receive an
									industry-recognized certificate of completion, which you can
									share with your friends, relatives, co-workers, and potential
									employers.
								</div>
							</div>
						</div>
					</div>
				</section>

				<section id="upgrade">
					<div className="center_wrapper">
						<h2>
							Upgrade yourself to the latest developments and trends in the
							Industry
						</h2>

						<div className="left_pane">
							<div>
								<div>
									<div
										className="circle_icon"
										style={{
											backgroundImage: `url("${process.env.PUBLIC_URL}/assets/pace.png")`,
										}}
									></div>
									<hr className="hr" />
								</div>
								<div className="content">
									<div className="heading">Go at your own pace</div>
									<div>
										Gone are the days when you needed to show up in a
										classNameroom to learn something new. At Wyden, we offer
										complete freedom to learn at your own pace and convenience.
									</div>
								</div>
							</div>
							<div>
								<div>
									<div
										className="circle_icon"
										style={{
											backgroundImage: `url("${process.env.PUBLIC_URL}/assets/star.png")`,
										}}
									></div>
									<hr className="hr" />
								</div>
								<div className="content">
									<div className="heading">Learn from industry experts</div>
									<div>
										Based on industry-defined and federally endorsed standards,
										Wyden offers an online network of resources designed
										meticulously by experienced industry experts, to make
										upskilling more accessible to employees at all levels of the
										company.
									</div>
								</div>
							</div>
							<div>
								<div
									className="circle_icon"
									style={{
										backgroundImage: `url("${process.env.PUBLIC_URL}/assets/ok.png")`,
									}}
								></div>
								<div className="content">
									<div className="heading">Make yourself industry ready</div>
									<div>
										At Wyden, we identify clear paths and milestones for
										performance measurement. This methodology gives employees
										insight into the process while also enabling them to move
										into bigger and better roles within the organization.
									</div>
								</div>
							</div>
						</div>
					</div>
					<img
						src={`${process.env.PUBLIC_URL}/assets/illustration1.png`}
						id="illustration1"
					/>
				</section>

				<section id="testimonials">
					<div className="center_wrapper">
						<Carousel
							showIndicators={true}
							showThumbs={false}
							showStatus={false}
						>
							<div className="slide_wrapper">
								<div className="face">
									<img
										src={`${process.env.PUBLIC_URL}/assets/face.png`}
										className="testimonial_face"
									/>
								</div>
								<div className="test-comma">
									<img
										src={`${process.env.PUBLIC_URL}/assets/comma.svg`}
										className="comma"
									/>
								</div>
								<div className="test-content">
									Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
									diam nonummy nibh euismod tincidunt Lorem ipsum dolor sit
									amet, consectetuer adipiscing elit, sed diam nonummy nibh
									euismod tincidunt Lorem ipsum dolor sit.
								</div>
								<br />
								<br />
								<div className="testimonial_name">~ D and M Interiors</div>
							</div>
							<div className="slide_wrapper">
								<div className="face">
									<img
										src={`${process.env.PUBLIC_URL}/assets/face.png`}
										className="testimonial_face"
									/>
								</div>
								<div className="test-comma">
									<img
										src={`${process.env.PUBLIC_URL}/assets/comma.svg`}
										className="comma"
									/>
								</div>
								<div className="test-content">
									Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
									diam nonummy nibh euismod tincidunt Lorem ipsum dolor sit
									amet, consectetuer adipiscing elit, sed diam nonummy nibh
									euismod tincidunt Lorem ipsum dolor sit.
								</div>
								<br />
								<br />
								<div className="testimonial_name">~ D and M Interiors</div>
							</div>
							<div className="slide_wrapper">
								<div className="face">
									<img
										src={`${process.env.PUBLIC_URL}/assets/face.png`}
										className="testimonial_face"
									/>
								</div>
								<div className="test-comma">
									<img
										src={`${process.env.PUBLIC_URL}/assets/comma.svg`}
										className="comma"
									/>
								</div>
								<div className="test-content">
									Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
									diam nonummy nibh euismod tincidunt Lorem ipsum dolor sit
									amet, consectetuer adipiscing elit, sed diam nonummy nibh
									euismod tincidunt Lorem ipsum dolor sit.
								</div>
								<br />
								<br />
								<div className="testimonial_name">~ D and M Interiors</div>
							</div>
						</Carousel>
					</div>
				</section>

				<section id="partners">
					<div className="center_wrapper">
						<h2>Our Partners</h2>
						<div className="partner_logos">
							<div>
								<img src={`${process.env.PUBLIC_URL}/assets/fosg.png`} />
							</div>
							<div>
								<img src={`${process.env.PUBLIC_URL}/assets/saint.png`} />
							</div>
						</div>
					</div>
				</section>

				<div id="footer_place">
					<Footer></Footer>
				</div>
			</div>
		</IonPage>
	);
};

export default Home;
